import React from 'react';
import HorizontalScroll from '../../HorizontalScroll';
import ReviewsItem from './ReviewsItem';
import profileUrl from '../../../utils/profileUrl';
import './styles.css';

const Reviews = ({ data }) => {
  return (
    <HorizontalScroll
      className="BusinessesList__Reviews__root"
      arrows
      data={data.map(
        ({
          id,
          rating,
          displayName: name,
          suburbName,
          state,
          message,
          listing: { name: businessName, hash },
        }) => {
          return (
            <ReviewsItem
              key={id}
              {...{
                rating,
                name,
                businessName,
                message,
                profileUrl: profileUrl({
                  name: businessName,
                  suburb: suburbName,
                  state,
                  hash,
                }),
              }}
            />
          );
        }
      )}
    />
  );
};

export default Reviews;
